import { render, staticRenderFns } from "./StepperPagination.vue?vue&type=template&id=2d7b37d7&scoped=true"
import script from "./StepperPagination.vue?vue&type=script&lang=js"
export * from "./StepperPagination.vue?vue&type=script&lang=js"
import style0 from "./StepperPagination.vue?vue&type=style&index=0&id=2d7b37d7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b37d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7b37d7')) {
      api.createRecord('2d7b37d7', component.options)
    } else {
      api.reload('2d7b37d7', component.options)
    }
    module.hot.accept("./StepperPagination.vue?vue&type=template&id=2d7b37d7&scoped=true", function () {
      api.rerender('2d7b37d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_v2/StepperPagination.vue"
export default component.exports